import { useState } from 'react'

import { Button, Typography, makeStyles } from '@material-ui/core'

import api from 'common/api'
import Title from 'components/Title'

import {
  useConfirmMatchToClassLinkSchool,
  useConfirmMatchToCleverSchool,
  useConfirmMatchToGoogleSchool,
  useRegistrationData,
  useSendInvite,
} from '../SignUpProvider/sign-up-context'
import { registrationErrorMessage } from './registration-errors'

const useStyles = makeStyles((theme) => ({
  buttonGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
}))

const MatchConfirm = () => {
  const classes = useStyles()
  const data = useRegistrationData()
  const [error, setError] = useState<string>()
  const sendInvite = useSendInvite()
  const confirmMatchToCleverSchool = useConfirmMatchToCleverSchool()
  const confirmMatchToClassLinkSchool = useConfirmMatchToClassLinkSchool()
  const confirmMatchToGoogleSchool = useConfirmMatchToGoogleSchool()
  const { matchedStudent } = data

  const showError = async (err: Parameters<typeof registrationErrorMessage>[0]) => {
    setError(await registrationErrorMessage(err))
  }
  const sendMatchInvite = (didConfirm: boolean) => {
    const invitee = didConfirm
      ? {
          ...matchedStudent,
          HighSchoolStudentId: matchedStudent?.Id,
          HighSchools: [matchedStudent?.HighSchool],
        }
      : {
          Email: data.email,
          HighSchools: [data.highSchool],
        }
    if (data?.regCode) {
      invitee.StudentIdOrRegCode = data.regCode
    }
    api
      .post('/api/student/register/invite', invitee)
      .then(() => {
        didConfirm ? sendInvite(matchedStudent) : sendInvite({ Email: invitee.Email, unmatched: true })
      })
      .catch(showError)
  }

  const confirmMatch = () => {
    const cleverRequired = data?.matchedStudent?.HighSchool?.CleverRequired || false
    const classLinkRequired = data?.matchedStudent?.HighSchool?.ClassLinkRequired || false
    const googleRequired = data?.matchedStudent?.GoogleSSORequired || false
    if (cleverRequired) {
      confirmMatchToCleverSchool()
    } else if (classLinkRequired) {
      confirmMatchToClassLinkSchool()
    } else if (googleRequired) {
      confirmMatchToGoogleSchool()
    } else {
      sendMatchInvite(true)
    }
  }

  const school = data?.matchedStudent?.HighSchool
  const hasLocation = school?.City && school?.State
  const findType = data?.birthDate ? 'account' : 'email address'
  return (
    <>
      <Title
        title={`Your ${findType} matches ${school?.HighSchoolName}${
          hasLocation ? ` in ${school.City}, ${school.State}` : ''
        } 📚`}
      />
      <div className={classes.buttonGroup}>
        {error && (
          <Typography
            role="alert"
            color="error"
          >
            {error}
          </Typography>
        )}
        <Button
          color="primary"
          variant="contained"
          onClick={confirmMatch}
        >
          Continue
        </Button>
        <Button
          color="primary"
          onClick={() => sendMatchInvite(false)}
        >
          This is not my school
        </Button>
      </div>
    </>
  )
}

export default MatchConfirm
